import { graphql } from '@/gql'

export const CustomFieldListFragment = graphql(/* GraphQL */ `
  fragment CustomFieldList on CustomField {
    id
    title
    slug
    appliesTo
    approval
    apiOnly
    visibility
    fieldType
    settings {
      validation
    }
    isUsedInFieldValues
    viewerCanUpdate
  }
`)

export const CustomFieldDetailFragment = graphql(/* GraphQL */ `
  fragment CustomFieldDetail on CustomField {
    id
    title
    slug
    description
    visibility
    approval
    apiOnly
    fieldType
    appliesTo
    settings {
      ...CustomFieldSettings
    }
    isUsedInFieldValues
    viewerCanUpdate
    customFieldOptions {
      ...CustomFieldOption
    }
    ...CustomFieldForFieldableValidation
  }
`)

export const CustomFieldForFieldableValidationFragment = graphql(/* GraphQL */ `
  fragment CustomFieldForFieldableValidation on CustomField {
    id
    title
    settings {
      ...CustomFieldSettings
    }
  }
`)

export const CustomFieldSettingsFragment = graphql(/* GraphQL */ `
  fragment CustomFieldSettings on CustomFieldSettings {
    validation
  }
`)

export const CustomFieldOptionFragment = graphql(/* GraphQL */ `
  fragment CustomFieldOption on CustomFieldOption {
    id
    value
    displayOrder
  }
`)
